






































































import { Component, Vue,Prop ,Watch} from "vue-property-decorator";
import _com from "@/assets/js/common";
import jsonp from "@/assets/js/http";
import fetch from "@/assets/js/fetch";
@Component({
    computed:{
        isUpdate(){
            let data = this.$store.getters["refresh/getLuckCardAllData"];
            if (data && data.updateListPop) {
                return true
            }
            return false
        }
    }
})
export default class luckCardListModal extends Vue {
    @Prop() diff: any = 0
	@Watch("diff") // 更新接收的值  ，不然只会显示第一次接收到的值
	watchDiff(newVal: number) {
		this.difference = newVal;
	}   
    difference: number = 0; 
    isCardShow: any = false
    browser = _com.browser();
    channel:any = '300000'
    cardListData:any = []
	get roomData() {//房间数据
        let roomData = this.$store.getters["getRoomDetail/getRoomDetail"];
		return roomData;
	}   
	get luckCardAllData() {
		let data: any = this.$store.getters["refresh/getLuckCardAllData"];
		return data;
	}	     
	stop(e: any) {
		e.stopPropagation();
	}
    isClick = true;
    @Watch('isUpdate') 
	onChange(val:any,oldVal:any){
        if (val) {
            console.log('通知更新列表');
            this.getCardList()
        }
	}
    close() { 
        clearInterval(this.roundTimer);
        this.roundTimer = null
        this.$store.dispatch('refresh/setLuckCardAllDataAsync',{key:'showListPop',value:false});
    }   
    roundTimer:any = null;
	coundDownTime(){
        clearInterval(this.roundTimer);
        this.roundTimer = setInterval(() => {
            this.cardListData.forEach((act: any) => {
                if (act.list && act.list.length > 0) {
                    act.list && act.list.forEach((round: any) => {
                        round.time--
                    });
                    act.list = act.list.filter((round: any) => round.time > 0) || []
                }
            });            
        }, 1000);
	}     
    getCardList() {
        this.$store.dispatch('refresh/setLuckCardAllDataAsync',{key:'updateListPop',value:false});
		jsonp(`https://m${process.env.VUE_APP_URI_DOMAIN}/mobileact/liveFuCard/queryFuCardList`, {
            roomName:this.$route.params.roomNumber,
		}).then((data: any) => {
            let isCountDown = false
            let batchIds:any = []
            data.forEach((act: any) => {
                if (act.userCardStatus == 14) {//已兑换
                    if (act.fuCardPrizeInfo && act.fuCardPrizeInfo.prizeBatchId) {
                        batchIds.push(act.fuCardPrizeInfo.prizeBatchId)
                    }
                } else if (act.list && act.list.length > 0) {
                    act.list && act.list.forEach((round: any) => {
                        round.time = Math.round((new Date(round.endTime).getTime() - (new Date().getTime() + this.difference))/1000)
                    });
                    act.list = act.list.filter((round: any) => round.time > 0) || []
                    if (act.list && act.list.length >0) {
                        isCountDown = true
                    }
                }
                
            });
            this.cardListData = data
            this.getCouponStatus(batchIds)
            if (isCountDown) {
                this.coundDownTime()
            } else {
                clearInterval(this.roundTimer);
                this.roundTimer = null
            }
		})     
    }
    claimCard(card:any){ //领卡
        if (!this.isClick) {
            return;
        }
		const callback = 'claimCard'
        let url = `https://service${process.env.VUE_APP_URI_DOMAIN}/act-assist/ulelivebarrage/api/v1/luckyCardActivity/user/receiveCard`;        
        let params:any = {
            roomName: this.roomData.roomNumber,
            sceneId: this.roomData.scene_id,
            cardNo:card.cardNo,
            roundId:card.roundId,
            batchId:card.id,
            channel:this.channel,     
        }
        console.log(this.roomData);
        console.log(card);
        this.isClick = false;
        fetch({
            url: url,
            params,
            method: "post"
        }).then((res: any) => {
            this.$toast('领取成功')
            card.userRoundStatus = 1
            setTimeout(()=>{
                this.getCardList()
                this.isClick = true;
            },2500)
        }).catch((err: any) => {
            this.isClick = true;
            this.$toast(err.msg || '领取失败请稍后重试')
        });              
    }
    combCard(card:any){ //合成卡
        if (!this.isClick) {
            return;
        }
        let url = `https://m${process.env.VUE_APP_URI_DOMAIN}/mobileact/liveFuCard/cardCombineDraw`;        
		const callback = 'combCard'
        this.isClick = false;
		jsonp(url, {
			jsoncallback: callback,
            cardActivityNo:card.cardActivityNo,
            channel:this.channel,   
		}).then((data: any) => {
            this.$toast(data.msg || '兑换成功')
            setTimeout(()=>{
                this.getCardList()
                this.isClick = true;
            },2500)
		}) .catch((err: any) => {
            this.isClick = true;
            this.$toast(err.message || '合卡失败请稍后重试')
        });        
    }   
    getCouponStatus(batchIds:any){ 
        let callback = "queryCardPrizeCoupon"
		let url = `//m${process.env.VUE_APP_URI_DOMAIN}/mobileact/ywsjAct/queryCouponByBatchId?batchIds=${batchIds.join(',')}&businessType=1,4&showChannelCode=activity&card=1&pageIndex=1&pageSize=10`        
        jsonp(url, {
            jsonp: "jsonCallback",
            jsonCallback: callback,
        }).then((data: any) => {
            // resolve(data);
            if (data.couponList && data.couponList.length > 0) {
                this.cardListData.forEach((act:any) => {
                    if (act.fuCardPrizeInfo && act.fuCardPrizeInfo.prizeBatchId) {
                        data.couponList.forEach((coupon: any) => {
                            let couponData:any = Object.assign({},act.fuCardPrizeInfo)
                            if (act.fuCardPrizeInfo.prizeBatchId == coupon.batchId) {
                                couponData = Object.assign(act.fuCardPrizeInfo,coupon, data.couponReceiveCountBatch[coupon.batchId]);
                            }
                            act.fuCardPrizeInfo = couponData
                            console.log(act.fuCardPrizeInfo);
                        });
                    }
                });
                this.$forceUpdate()
            }
        })
    } 
    goCoupon(coupon: any,act:any){
        if (!coupon.listingId) {
            return false
        }
        let codeType = act.codeType;
        let code = act.code;
        let listId = coupon.listingId.split(",")[0];
        let room = this.roomData
		let burialPoint = {
			url: location.href,
			ule_title: '直播间集卡优惠券',
			resource_type: '直播间集卡优惠券',
			resource_name: '直播间集卡优惠券',
			resource_content: coupon.batchName,
			resource_module: coupon.batchName,
			resource_inner_position: 0,
			resource_item_type: '优惠券',
			resource_item_id: coupon.batchId,
			remarks: room.roomNumber,
			resource_forward_url: ''
		}        
        // 邮乐优鲜小程序
        let path:string = ''
        let unionParams = `union_id=1016039300&union_ref=${room.roomNumber}_${room.scene_number}`
		if (this.$route.query.ul_aid) {
			unionParams += `&ul_aid=${this.$route.query.ul_aid}`
		}     
        if (this.$route.query.storeid && this.$route.query.shareId) {
            unionParams += `&storeid=${this.$route.query.storeid}&shareId=${this.$route.query.shareId}`
        }            
		if (this.browser.usqxcx) {
            if (codeType == 1) {//跳转接龙
                path = `/packageA/solitaire/index?activityCode=${code}&listId=${listId}&${unionParams}`;
            } else {//跳详情
                path = `/packageA/item/item?listId=${listId}&${unionParams}`;
            }
			(<any>window).wx.miniProgram.navigateTo({ url:  path })//邮乐优鲜小程序详情页
		} else {
            if (codeType == 1) {//跳转接龙
                if (this.browser.ylxdsq) {
                    if (_com.isIos()) {
                        path = `objc:ulemobile://action&&WebDetailViewController:0&&key:https@@//h5${process.env.VUE_APP_URI_DOMAIN}/yxd/community/ylsq/editGroup/${code}?listId=${listId}&isCheck=1&${unionParams}`;
                    } else if (_com.isAndroid()) {
                        path = `ulemobile://action&&ui.MyBusinessWebView##load_url::https://h5${process.env.VUE_APP_URI_DOMAIN}/yxd/community/ylsq/editGroup/${code}?listId=${listId}&isCheck=1&${unionParams}`;
                    }                    
                } else {
                    path = `//h5${this.domain}/yxd/community/chains/chainsDetail/${code}?listId=${listId}&${unionParams}`;
                }
            } else {
                path = "//h5" + this.domain + "/yxd/community/item/itemPage/" + listId + "?" + unionParams + '&toSeckillLive=' + room.roomNumber;
            }            
			location.href = path
        }
        burialPoint['resource_forward_url'] = path
		_com.sendSensorTrack('btnClick', room, burialPoint)
    }
    hideCardList() {
		this.isCardShow = false;
	}
    navIndex: number = 0;
    cardActData: any = {};
	mounted() {
		if (this.browser.ylxdsq) {
			this.channel = '610003'	
		} else if (this.browser.usqxcx) {
			this.channel = '610002'	
		} else if (this.browser.ylxd) {
			this.channel = '600000'
		} else if (this.browser.yzgxd) {
			this.channel = '400006'
		} else if (this.browser.ule) {
			this.channel = '200000'
		}          
        this.getCardList()
        this.isCardShow = true;
	}
	destroyed() {
		clearInterval(this.roundTimer);
		this.roundTimer = null
	}
    beforeDestroy() {
		clearInterval(this.roundTimer);
    }
}

